import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import { membershipApi } from '../services/api';
import './RedeemPage.css';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Completing your membership...');
  const [error, setError] = useState('');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (!sessionId) {
      setStatus('error');
      setError('No session ID found. Please contact support.');
      return;
    }

    const completeMembership = async () => {
      // Retry logic - try up to 5 times with delays
      for (let attempt = 1; attempt <= 5; attempt++) {
        try {
          setMessage(`Completing your membership... (attempt ${attempt})`);
          
          const result = await membershipApi.checkPaymentStatus(sessionId);
          
          console.log('Payment status result:', result);
          
          if (result.status === 'complete' || 
              result.payment_status === 'paid' || 
              result.payment_status === 'no_payment_required') {
            setStatus('success');
            setMessage(`Welcome! You are now a ${result.membership_name || 'premium'} member.`);
            
            // Wait 3 seconds then redirect to dashboard
            setTimeout(() => {
              navigate('/dashboard');
            }, 3000);
            return;
          }
          
          // If not complete yet, wait and retry
          if (attempt < 5) {
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        } catch (err) {
          console.error(`Attempt ${attempt} failed:`, err);
          if (attempt === 5) {
            setStatus('error');
            setError('Unable to verify payment. Please refresh or contact support.');
          } else {
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        }
      }
    };

    completeMembership();
  }, [searchParams, navigate]);

  return (
    <div className="redeem-page">
      <div className="redeem-container">
        <div className="redeem-header">
          {status === 'processing' && (
            <>
              <Loader2 size={48} className="spin" style={{ color: '#22c55e' }} />
              <h1>Processing...</h1>
              <p>{message}</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <CheckCircle size={48} style={{ color: '#22c55e' }} />
              <h1>Success!</h1>
              <p>{message}</p>
              <p style={{ fontSize: '0.9rem', opacity: 0.7, marginTop: '1rem' }}>
                Redirecting to dashboard...
              </p>
            </>
          )}
          
          {status === 'error' && (
            <>
              <AlertCircle size={48} style={{ color: '#ef4444' }} />
              <h1>Something went wrong</h1>
              <p>{error}</p>
              <button 
                onClick={() => navigate('/dashboard')}
                className="claim-btn primary"
                style={{ marginTop: '1rem' }}
              >
                Go to Dashboard
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
